import { SchemaSupport } from '@/models/SchemaSupport.js';

export const initialState = {
    form_data: new SchemaSupport(),
    state: 'list',
    currentTicket: ''
}

export const state = initialState
